import oAxiosInstance from "config/Axios";

export const apiCallGetAllDocumentTypes = (sFilter = "") => {
  return oAxiosInstance.get(`tiposdedocumentos/${sFilter}`);
};
